import { ISelectItem, Select } from 'components/UI/Select/Select'

import type { AgentMeta } from './agentTypeMetadata'

interface Props {
  agentTypes: AgentMeta[]
  selected: string | null
  onSelect: (agentType: string) => void
}

export function AgentTypeSelect({ agentTypes, selected, onSelect }: Props) {
  const items: ISelectItem<string>[] = agentTypes.map((agent) => ({
    label: (
      <div className="flex flex-col">
        <span className="font-medium">{agent.name}</span>
        <span className="text-xs text-fg-secondary">{agent.description}</span>
      </div>
    ),
    labelWhenSelected: agent.name,
    value: agent.agent_type,
  }))

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-medium text-fg">Column Type</label>
      <Select<string>
        items={items}
        selected={selected ?? undefined}
        onSelect={(value) => value && onSelect(value)}
        nullSelectionLabel="Select a column type…"
        searchPlaceholder="Search column types…"
        buttonClassName="w-full"
        matchTriggerWidth
      />
    </div>
  )
}
